import type { FoxAttack } from '../../../data/full/enracine';
import { applyEnemyStatus } from '../../enemy-status';
import { touches } from '../../effects';
import { type GaugeModule, gaugeValue, setGauge } from '../../gauges';
import type { PlayerState } from '../../state';
import { statValue } from '../../stats';

// Long enough that a bad vibe held in the roots stays slowed from one tick to the next.
const SLOW_TICKS = 2;

export const racinesGauge: GaugeModule = (ctx, player, gauge, definition) => {
  const { state, tempo } = ctx;
  const { attack } = definition;
  if (attack.kind !== 'fox') {
    throw new Error(`class "${definition.id}" has Racines but no fox`);
  }
  const dx = player.x - player.prevX;
  const dy = player.y - player.prevY;
  const still = !player.downed && dx === 0 && dy === 0;
  const step = still
    ? statValue(player, 'rootsGrowthMul', 1) / tempo.ticksPerBar
    : -1 / tempo.ticksPerBeat;
  const value = gaugeValue(player) + step;
  // A sum of steps lands on a whole notch exactly.
  const whole = Math.round(value);
  setGauge(player, gauge, Math.abs(value - whole) < Math.abs(step) / 2 ? whole : value);

  const notches = rootNotches(player);
  if (notches < attack.roots.slowFrom) {
    return;
  }
  const radius = rootsRadius(attack, notches);
  for (const enemy of state.enemies) {
    if (enemy.hp > 0 && touches(enemy, player, radius)) {
      applyEnemyStatus(state, enemy, 'slowed', SLOW_TICKS);
    }
  }
};

export function rootNotches(player: Pick<PlayerState, 'gauge'>): number {
  return Math.floor(gaugeValue(player));
}

export function rootsRadius(attack: Pick<FoxAttack, 'roots'>, notches: number): number {
  return attack.roots.radius + attack.roots.perNotch * notches;
}
